import { connect } from 'react-redux';
import Segment from 'helpers/segment';
import { selectActiveVenueId } from 'selectors/general';

import ScheduleListFilter from './ScheduleListFilter';
import { selectScheduleListFilter } from './YieldManagement.selectors';
import { setScheduleListFilter as setScheduleListFilterAction } from './YieldManagement.reducers';

const mapStateToProps = state => {
  const selectedFilterKey = selectScheduleListFilter(state);
  const venueId = selectActiveVenueId(state);

  return {
    selectedFilterKey,
    venueId,
  };
};

const mapDispatchToProps = {
  setScheduleListFilterAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { venueId, ...restStateProps } = stateProps;
  return {
    ...restStateProps,
    setScheduleListFilter: filter => {
      Segment.event('Click Class Type Filter', { venueId, type: filter });
      dispatchProps.setScheduleListFilterAction(filter);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ScheduleListFilter);
